import OrganizationsTable from './OrganizationsTable'
export default OrganizationsTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/OrganizationTab/OrganizationTable/index.js